import { bl_dgmkt_project_line_RowClass } from '../../../dbschema/bl_dgmkt_project_line.model';
import { BaseContainerModel } from '../../base-container.model';

export class DgMktProjectLineContainerModel extends BaseContainerModel {
  bl_dgmkt_project_line: bl_dgmkt_project_line_RowClass = new bl_dgmkt_project_line_RowClass();
}
